import { ArchivePollDaysResponse, PollOverview, PollDaysResponse } from './api.types';

const transformArchiveData = (response: ArchivePollDaysResponse): PollDaysResponse => {
  const transformIssues = (issues: ArchivePollDaysResponse['data'][0]['issues']) => {
    return issues.map((issue) => {
      return {
        id: issue.info.id,
        frontend_id: null,
        resources: issue.info.resources,
        date: issue.info.date,
        polling_day_id: issue.info.polling_day_id,
        polling_day_frontend_id: null,
        type: issue.info.type,
        domain_type: issue.info.domain_type,
        domain_id: '',
        scope: issue.info.scope,
        domain_bfs_number: '',
        domain_name: issue.info.domain_name,
        aggregating_domain_type: null,
        title: issue.info.title,
        short_title: issue.info.short_title,
        info: null,
        sort_key: 0,
        poll_info: issue.info.poll_info,
        majority_election_info: issue.info.majority_election_info,
        proportional_election_info: issue.info.proportional_election_info,
      } as PollOverview;
    });
  };

  const transformedData = response.data
    .map((issue) => {
      const { issues, ...rest } = issue;

      return {
        ...rest,
        date: issue.date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1'),
        issues: transformIssues(issues),
      };
    })
    .sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      return dateB.getTime() - dateA.getTime();
    });

  return {
    data: transformedData,
  };
};

export default transformArchiveData;
